'use client'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import Image from 'next/image'
import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
interface MenuItemType {
  key: string
  label: React.ReactNode
  children?: MenuItemType[] // Hỗ trợ lồng menu con
}

interface DropdownCategoriesProps {
  menu?: { items: MenuItemType[] }
}

export const DropdownCategories = ({ menu }: DropdownCategoriesProps) => {
  const [hovered, setHovered] = useState<boolean>(false)
  const t = useTranslations()
  const isShowMenu = hovered && menu?.items && menu?.items?.length > 0
  return (
    <div
      className="relative flex h-full cursor-pointer items-center gap-4 duration-500"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="w-[20px]">
        <Image src="/assets/images/ico_menu.svg" width={20} height={10} alt="Danh mục sản phẩm" />
      </div>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        <p className="whitespace-nowrap">{t('Header.product-category-label')}</p>
      </motion.div>
      <AnimatePresence>
        {isShowMenu && (
          <motion.ul
            initial={{ opacity: 0.4, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.1 }}
            className="absolute left-0 top-full z-50 w-48 rounded-sm border border-gray-200 bg-white text-primary  shadow-lg"
          >
            <Menu items={menu?.items} />
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  )
}

const Menu = ({ items }: { items: MenuItemType[] | undefined }) => {
  return <>{items?.map((item, index) => <MenuItem item={item} key={index} />)}</>
}

const MenuItem = ({ item }: { item: MenuItemType }) => {
  const [hovered, setHovered] = useState<boolean>(false)
  return (
    <li
      className="group relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="flex items-center justify-between px-4 py-2 duration-100 hover:bg-gray-200 ">
        {item.label}
        {item.children && <KeyboardArrowRightIcon fontSize="small"></KeyboardArrowRightIcon>}
      </div>

      {item.children && hovered && (
        <ul className="absolute left-full top-0 hidden w-48 rounded border border-gray-200 bg-white text-primary group-hover:block">
          <Menu items={item.children} />
        </ul>
      )}
    </li>
  )
}
